export default __webpack_public_path__ + "static/media/skateboard-LOOC-B-how-to-video-2.ee870306.mp4";